import React from 'react'
import styled from 'styled-components'
import EcoSystemBG01 from '../../../../assets/bg/pc/bg_ecosystem_01.png'
import EcoSystemBG02 from '../../../../assets/bg/pc/bg_ecosystem_02.png'
import EcoSystemBG03 from '../../../../assets/bg/pc/bg_ecosystem_03.png'
import EcoSystemBG04 from '../../../../assets/bg/pc/bg_ecosystem_04.png'
import EcoSystemBG05 from '../../../../assets/bg/pc/bg_ecosystem_05.png'

const EcosystemPCComponent = () => {
  return (
    <StyledWrap>
      <img src={EcoSystemBG01} />
      <img src={EcoSystemBG02} />
      <img style={{ marginTop: 213 }} src={EcoSystemBG03} />
      <img style={{ marginTop: 213, paddingLeft: 280, paddingRight: 280 }}  src={EcoSystemBG04} />
      <img className={'ecosystem_04'} src={EcoSystemBG05} />
    </StyledWrap>
  )
}

export default EcosystemPCComponent

const StyledWrap = styled.div`
  .ecosystem_04 {
    width: 67%;
    margin: 148px auto 217px;
  }
`
